import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { injectIntl } from "react-intl";
import NavBarDropdown from "./NavBarDropdown";
import { AccountIcon } from "cxa-icons";
import { ClickOutside } from "../../common/ClickOutsideWrapper";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { decodeHtmlContent } from "../../../utils";
import BlueUpperArrow from "../../../assets/images/svg/blue-arrow-up-icon.svg";
import BlueDownArrow from "../../../assets/images/svg/blue_bottom_arrow.svg";
import { useSelector } from "react-redux";
import messages from "components/messagesDescription";

const setAccountLabel = (navBox, secondaryNavBox, account, accountIcon, accountLabel, cartBox) => {
  accountLabel.setAttribute("aria-hidden", false);
  accountIcon.setAttribute("aria-hidden", true);

  let cartHeight = 0;
  let cartAdjustment = 0;
  if (cartBox) {
    cartHeight = cartBox.offsetHeight;
    cartAdjustment = Math.max((cartHeight - account.offsetHeight) / 2, 0);
  }

  const overSized =
    (account.offsetTop - cartAdjustment > secondaryNavBox.offsetTop && cartHeight > 0) ||
    account.offsetWidth + account.offsetLeft - secondaryNavBox.offsetLeft >
      secondaryNavBox.offsetWidth;

  accountLabel.setAttribute("aria-hidden", overSized);
  accountIcon.setAttribute("aria-hidden", !overSized);

  navBox.classList.toggle("apl-header__nav--iconic", !overSized && cartHeight === 0);
};

const Navbar = ({
  isDropdownOpen,
  dropdownToggle,
  children,
  displayedName,
  messaging: {
    menu: { isMessagingEnabled = false },
    unreadMessageCount,
  },
  isTabletScreen,
  isPhoneScreen,
  newUIFlag,
  intl,
}) => {
  const navBox = useRef(null);
  const secondaryNavBox = useRef(null);
  const accountBox = useRef(null);
  const accountIcon = useRef(null);
  const accountLabel = useRef(null);
  const cartBox = useRef(null);

  const handleWindowResize = () => {
    setAccountLabel(
      navBox.current,
      secondaryNavBox.current,
      accountBox.current,
      accountIcon.current,
      accountLabel.current,
      cartBox.current
    );
  };

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const isNarrowScreen = isTabletScreen || isPhoneScreen;

  const clientSettings = useSelector(state => state.common.clientSettings);
  const dashboardActionsData = useSelector(state => state.dashboardPP.dashboardActions);

  const totalLength = dashboardActionsData ? dashboardActionsData.totalNotificationsAction : 0;

  return (
    <nav className={`apl-header__nav apl-header__nav--secondary navbar-label-pp`} ref={navBox}>
      {clientSettings.newUIFlag && (
        <span className={`notification-count-pp  ${totalLength > 0 ? " with-background" : ""}`}>
          {totalLength}
        </span>
      )}
      <ul ref={secondaryNavBox} style={newUIFlag ? { paddingTop: "8px" } : {}}>
        <li className="apl-drop-menu apl-header__nav-item--account" ref={accountBox}>
          <ClickOutside handler={event => dropdownToggle(event, false)}>
            <button className="link apl-header__nav-item flex-middle" onClick={dropdownToggle}>
              <span ref={accountIcon} className="apl-icon">
                <AccountIcon />
                <span>{intl.formatMessage(messages.meDescription)}</span>
              </span>
              <a href="#" ref={accountLabel}>
                {clientSettings.newUIFlag
                  ? intl.formatMessage(messages.meDescription)
                  : decodeHtmlContent(displayedName)}
              </a>
              {isMessagingEnabled && (
                <div className="apl-badge">{isNarrowScreen ? "" : unreadMessageCount}</div>
              )}
              {clientSettings.newUIFlag &&
                (isDropdownOpen ? (
                  <BlueUpperArrow style={{ width: "15px", height: "15px", marginLeft: "10px" }} />
                ) : (
                  <BlueDownArrow style={{ width: "15px", height: "15px", marginLeft: "10px" }} />
                ))}
            </button>
            <NavBarDropdown displayedName={displayedName} isOpen={isDropdownOpen}>
              {children}
            </NavBarDropdown>
          </ClickOutside>
        </li>
      </ul>
    </nav>
  );
};

Navbar.propTypes = {
  isDropdownOpen: PropTypes.bool,
  dropdownToggle: PropTypes.func,
  dropdownItems: PropTypes.array,
  cartPath: PropTypes.string,
  children: PropTypes.array,
  displayedName: PropTypes.string,
  newShopUrl: PropTypes.string,
  messageCount: PropTypes.string,
  isTabletScreen: PropTypes.bool,
  isPhoneScreen: PropTypes.bool,
  messaging: PropTypes.object.isRequired,
  newUIFlag: PropTypes.bool,
  intl: PropTypes.func,
};

export default withMatchMediaProps({
  isTabletScreen: {
    maxWidth: 719,
    minWidth: 420,
  },
  isPhoneScreen: {
    maxWidth: 419,
  },
})(injectIntl(Navbar));



// WEBPACK FOOTER //
// ./components/common/navigation/NavBar.js